import { runDemo } from "../shared/demoRunner";
import { createAdvancedShadowsScene } from "./scene";

runDemo({ createScene: createAdvancedShadowsScene });
